/*
  eci: the multibuy tier buttons on the product page (snippets/eci-multibuy.liquid). Tapping a tier sets the quantity,
  the matching tier highlights as the quantity changes, and the prices follow the selected variant. Guards against
  defining the element twice.
*/
(() => {
  if (customElements.get('eci-multibuy')) return;
  class EciMultibuy extends HTMLElement {
    connectedCallback() {
      // The quantity input comes after this block in the page, so wait for the whole form to be parsed
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }
    init() {
      if (this.ready) return;
      this.ready = true;
      this.form = document.getElementById(this.getAttribute('form-id'));
      this.input = document.querySelector(`input[name="quantity"][form="${this.getAttribute('form-id')}"]`);
      this.tiers = Array.from(this.querySelectorAll('.eci-mb__tier'));
      this.tiers.forEach((t) => t.addEventListener('click', () => this.setQty(parseInt(t.dataset.qty, 10))));
      if (this.input) {
        ['input', 'change', 'keyup'].forEach((e) => this.input.addEventListener(e, () => this.sync()));
        const sel = this.input.closest('quantity-selector');
        if (sel) sel.addEventListener('click', () => setTimeout(() => this.sync(), 0));
      }
      if (this.form) this.form.addEventListener('variant:changed', (e) => this.reprice(e.detail && e.detail.variant));
      this.sync();
    }
    setQty(q) {
      if (!this.input) return;
      if ('quantity' in this.input) { this.input.quantity = q; } else { this.input.value = q; }
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    }
    sync() {
      const q = this.input ? parseInt(this.input.value, 10) || 1 : 1;
      let best = null;
      this.tiers.forEach((t) => { if (q >= parseInt(t.dataset.qty, 10)) best = t; });
      this.tiers.forEach((t) => t.setAttribute('aria-pressed', t === best ? 'true' : 'false'));
    }
    reprice(variant) {
      if (!variant || typeof variant.price !== 'number') return;
      this.tiers.forEach((t) => {
        const off = parseInt(t.dataset.off, 10), qty = parseInt(t.dataset.qty, 10);
        const price = t.querySelector('[data-role="price"]'), save = t.querySelector('[data-role="save"]');
        if (price) price.textContent = this.money(Math.max(variant.price - off, 0));
        if (save) save.textContent = save.textContent.replace(/\S+$/, this.money(off * qty));
      });
    }
    money(cents) {
      const fmt = this.dataset.moneyFormat;
      const n = (cents / 100).toFixed(2);
      if (!fmt) return '€' + n;
      const withComma = n.replace('.', ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k.indexOf('comma') > -1 ? withComma : k === 'amount_no_decimals' ? String(Math.round(cents / 100)) : n));
    }
  }
  customElements.define('eci-multibuy', EciMultibuy);
})();

